import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { getMyHubListings } from '../../util/api';

// ================ Action types ================ //

export const SEARCH_LISTINGS_REQUEST = 'app/MyHubPage/SEARCH_LISTINGS_REQUEST';
export const SEARCH_LISTINGS_SUCCESS = 'app/MyHubPage/SEARCH_LISTINGS_SUCCESS';
export const SEARCH_LISTINGS_ERROR = 'app/MyHubPage/SEARCH_LISTINGS_ERROR';

// ================ Reducer ================ //

const initialState = {
  searchInProgress: false,
  searchListingsError: null,
  resultIds: [],
};

const resultIds = data => data.data.map(l => l.id);

const myHubPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_LISTINGS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
        searchListingsError: null,
      };
    case SEARCH_LISTINGS_SUCCESS:
      return {
        ...state,
        resultIds: resultIds(payload.data),
        searchInProgress: false,
      };
    case SEARCH_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, searchInProgress: false, searchListingsError: payload };

    default:
      return state;
  };
};

export default myHubPageReducer;

// ================ Action creators ================ //

export const searchListingsRequest = () => ({
  type: SEARCH_LISTINGS_REQUEST,
  payload: {},
});

export const searchListingsSuccess = response => ({
  type: SEARCH_LISTINGS_SUCCESS,
  payload: { data: response.data },
});

export const searchListingsError = e => ({
  type: SEARCH_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const searchListings = (config) => (dispatch, getState, sdk) => {
  dispatch(searchListingsRequest());

  return getMyHubListings({})
    .then(response => {
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };

      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(searchListingsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(searchListingsError(storableError(e)));
      throw e;
    });
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  return dispatch(searchListings(config));
};
